module.exports = __webpack_public_path__ + "static/media/perfect-gold_00005.ea4ec88e.png";